import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

import { ContentWrapper } from "../components/Nav";
import { AddButton } from "../components/Button";
import { PackageModal, ViewPackage } from "../components/Modal";
import PackageListing from "../components/Listing/PackageListing";
import "./styles/Packages.scss";

class Packages extends React.Component {
  state = {
    packages: this.props.userData.packages || {},
    newPackageModalOpen: false,
    viewPackageModalOpen: false,
    pkgClicked: {},
    pkgClickedColor: undefined
  };

  componentWillReceiveProps(nextProps) {
    // new search value encountered
    if (this.props.searchValue !== nextProps.searchValue) {
      let packages = { ...this.props.userData.packages };

      // see if it's worth filtering even
      if (nextProps.searchValue.length > 0) {
        const searchString = nextProps.searchValue.toLowerCase();

        // loop through each key
        for (var key in packages) {
          if (packages.hasOwnProperty(key)) {
            // filter packages
            let packageList = packages[key];
            packageList = packageList.filter(
              ({ name, deliveryDate, location }) => {
                return (
                  `${name} ${deliveryDate} ${location}`
                    .toLowerCase()
                    .indexOf(searchString) !== -1
                );
              }
            );

            // put back in object
            packages[key] = packageList;
          }
        }
      }

      this.setState({ packages });
    }
  }

  packageClicked = (e, color) => {
    const [category, index] = e.currentTarget.id.split("_");

    this.setState({
      viewPackageModalOpen: true,
      pkgClicked: this.state.packages[category][index],
      pkgClickedColor: color
    });
  };

  renderPackageList = (category, color) => {
    const packages = this.state.packages;

    return (
      packages[category] &&
      packages[category].map((pkg, index) => (
        <Col sm={6} key={index} className="minorCol">
          <PackageListing
            name={pkg.name}
            date={pkg.deliveryDate}
            location={pkg.location}
            color={color}
            onClick={e => this.packageClicked(e, color)}
            id={`${category}_${index}`}
          />
        </Col>
      ))
    );
  };

  render() {
    return (
      <ContentWrapper style={{ backgroundColor: "#F2F6FA" }}>
        <PackageModal
          open={this.state.newPackageModalOpen}
          onClose={() => this.setState({ newPackageModalOpen: false })}
        />
        <ViewPackage
          pkg={this.state.pkgClicked}
          open={this.state.viewPackageModalOpen}
          color={this.state.pkgClickedColor}
          onClose={() => this.setState({ viewPackageModalOpen: false })}
        />
        <Container style={{ padding: "30px 5%" }}>
          <Row>
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <AddButton
                onClick={() => this.setState({ newPackageModalOpen: true })}
              >
                ADD PACKAGE
              </AddButton>
            </Col>
          </Row>

          <Row>
            <Col md className="majorCol">
              <h3 className="sectionTitle">Ready To Pickup</h3>
              <Row>{this.renderPackageList("Arrived", "#FF5757")}</Row>
            </Col>
            <Col md className="majorCol">
              <h3 className="sectionTitle">On The Way</h3>
              <Row>{this.renderPackageList("On the way", "#00CCFF")}</Row>
            </Col>
          </Row>
          <Row>
            <Col md className="majorCol">
              <h3 className="sectionTitle">Completed Pickups</h3>
              <Row>{this.renderPackageList("Picked up", "#555C64")}</Row>
            </Col>
            <Col md />
          </Row>
        </Container>
      </ContentWrapper>
    );
  }
}

Packages.propTypes = {
  searchValue: PropTypes.string
};

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Packages);
